import React from 'react'
import './styles.css'
import SvgIcon, { iconList } from '../../share/components/iconSVG'
import { Link } from 'react-router-dom'


const ButtonsContactSecure = () => {
  return (
    <div className='Contain-Buttons-secure'>
      <Link to={'https://wa.link/uq1q0p'} target='blank'>
        <button >
          <div className='Contain-Buttons-secure-icon'>
            <SvgIcon name={iconList.IconPaperList} color={'#004274'} size={120} />
          </div>
          <div className='Contain-Buttons-secure-p'>
            <p className='title-button'>¿Necesitas una previa cotizacion?</p>
            <p className='description-button'>Dejanos tus datos, te contactaremos con todtu cotización solicitada</p>
          </div>
        </button>
      </Link>
      <Link to={'https://wa.link/uq1q0p'} target='blank'>
        <button >
          <div className='Contain-Buttons-secure-icon'>
            <SvgIcon name={iconList.IconCheckBuy} color={'#004274'} size={120} />
          </div>
          <div className='Contain-Buttons-secure-p'>
            <p className='title-button'>Haz la compra de tu seguro de viaje</p>
            <p className='description-button'>Dejanos toda la info necesaria para que adquieras tu seguro de viaje</p>
          </div>
        </button>
      </Link>

    </div>
  )
}

export default ButtonsContactSecure